/** @file effectiveRotate: an entry's rotate rule after rotateOff and the key's rotToggle (18.10). */
import type { FacetEntry, RotateMode } from '@zilo/pose3d-format/types/facet';

/**
 * Plan decision 23: `ground` stays `ground`; otherwise rotation is on when `!entry.rotateOff`, inverted by `rotToggle`;
 * on -> `entry.rotate`, off -> `'none'`.
 */
export function effectiveRotate(entry: Pick<FacetEntry, 'rotate' | 'rotateOff'>, rotToggle: boolean): RotateMode {
  if (entry.rotate === 'ground') return 'ground';
  const on = (entry.rotateOff !== true) !== rotToggle;
  return on ? entry.rotate : 'none';
}
